function Animation(toAnimate) {
    this.obj = toAnimate;
    this.obj.ready = false;
}

Animation.prototype.prepare = function(arg) {
    this.obj.animated = true;
    if(this.obj.prepare && !this.obj.ready) {
        this.obj.ready = true;
        this.obj.prepare(arg);
    }
}

Animation.prototype.animate = function(arg) {
    if(this.obj.animate) {
        this.obj.animate(arg);
    }
}

Animation.prototype.stop = function(arg) {
    this.obj.animated = false;
    if(this.obj.stop) {
        this.obj.stop(arg);
    }
}

Animation.prototype.getObj = function() {
    return this.obj;
}

export default Animation;
